import { render, staticRenderFns } from "./TestPhaseOverCard.vue?vue&type=template&id=1f200afc&scoped=true&"
import script from "./TestPhaseOverCard.vue?vue&type=script&lang=js&"
export * from "./TestPhaseOverCard.vue?vue&type=script&lang=js&"
import style0 from "./TestPhaseOverCard.vue?vue&type=style&index=0&id=1f200afc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f200afc",
  null
  
)

export default component.exports